import React from "react";
import { Eyebrow } from "../page/HomePage";

/* Styles the policy text from here so each page only holds its content */
const bodyClass = [
  "text-[15px] sm:text-base leading-relaxed text-[#5b6b66]",
  "[&_p]:mb-4 [&_p]:text-[15px] sm:[&_p]:text-base [&_p]:leading-relaxed [&_p]:text-[#5b6b66]",
  "[&_strong]:font-semibold [&_strong]:text-[#0d2f27]",
  "[&_h2]:mt-9 [&_h2]:mb-4 [&_h2]:border-t [&_h2]:border-[#0d2f27]/[0.08] [&_h2]:pt-7 [&_h2]:text-lg sm:[&_h2]:text-xl [&_h2]:font-extrabold [&_h2]:leading-snug [&_h2]:text-[#0d2f27]",
  "[&_ul]:mt-4 [&_ul]:mb-0 [&_ul]:!pl-0 [&_ul]:list-none [&_ul]:space-y-3",
  "[&_li]:rounded-2xl [&_li]:bg-[#eef6f0] [&_li]:p-4 [&_li]:text-[15px] [&_li]:leading-relaxed [&_li]:text-[#5b6b66] [&_li]:ring-1 [&_li]:ring-black/5",
  "[&_a]:font-semibold [&_a]:text-[#1f8a4f] hover:[&_a]:text-[#0d2f27]",
  "[&_i]:mb-5 [&_i]:block [&_i]:text-[#5b6b66]",
].join(" ");

const PolicyLayout = ({ title, children }) => (
  <div className="flow-root bg-[#f6f5f0] pb-20">
    {/* Intro band */}
    <section className="m-3 rounded-2xl bg-[#0b2a23] bg-hero-card bg-hero-grid px-4 pb-28 pt-16 sm:px-6 lg:pt-20">
      <div className="mx-auto max-w-3xl text-center">
        <Eyebrow tone="dark">Swasth OPD</Eyebrow>
        <h1 className="mt-[20px] mb-[0px] text-[34px] sm:text-[44px] xl:text-[52px] font-extrabold leading-[1.08] tracking-[-0.03em] text-white">
          {title}
        </h1>
      </div>
    </section>

    {/* Policy text, pulled up over the band */}
    <div className="relative mx-auto -mt-20 max-w-7xl px-4 sm:px-6 lg:px-8">
      <article
        className={`rounded-[24px] bg-white p-6 ring-1 ring-black/5 shadow-[0_10px_40px_-20px_rgba(13,47,39,0.25)] sm:p-10 ${bodyClass}`}
      >
        {children}
      </article>
    </div>
  </div>
);

export default PolicyLayout;
